import _ from 'lodash';

import storage, { RangeLimit } from '@/renderer/scripts/utils/storage';
import { StoreKey } from '@/renderer/scripts/utils/storage/StoreKey';
import { formEqualHandler } from '@/renderer/components/dialog/setting/composition/formEqualHandler';
import { storageCache } from '@/renderer/scripts/utils/storage/StorageCache';

/**
 * localStorage的保存和读取
 * @param formData 表单数据(需要深拷贝，移除响应式)
 * @param storageKey key
 */
export default (formData: RangeLimit, storageKey: StoreKey) => {
  // 设置传输列表的并发数量
  const setStorage = _.debounce(
    () => {
      const newFormData = JSON.parse(JSON.stringify(formData)) as unknown as RangeLimit;
      return storageCache.set(storageKey, newFormData);
    },
    2000,
    { leading: true },
  );

  const storageMethods = {
    /**
     * 设置配置值到storage中，防抖函数
     * @description TODO 这里还需要沟通到传输列表中去
     * @type DebouncedFuncLeading
     */
    setStorage: _.debounce(
      (formData: RangeLimit, storageKey: StoreKey) => {
        const newFormData = JSON.parse(JSON.stringify(formData)) as unknown as RangeLimit;
        return storageCache.set(storageKey, newFormData);
      },
      2000,
      { leading: true },
    ),
    /**
     * @version since 2.5.0 在2.5.0 以后清理多余的key
     */
    clearDeprecatedStorage() {
      // batchLimit: 5
      // chunkParallelLimit: 5
      // retryLimit: 5
    },
    /**
     *
     * 从本地存储读取上次保存数据,
     * @description 范围：[PC端]， 注意：用户有可能没有修改过，意味着读出来的数据为undefined
     */
    initDataFromStorage: () => {
      storageMethods.clearDeprecatedStorage();
      const storageRangeSetting: RangeLimit = storage.get<RangeLimit>(storageKey);
      if (!storageRangeSetting) return;
      // 文件并发数量
      if (storageRangeSetting.batchLimit !== undefined) formData.batchLimit = storageRangeSetting.batchLimit;
      // 传输模式：true为最优模式模式
      if (storageRangeSetting.batchAuto !== undefined) formData.batchAuto = storageRangeSetting.batchAuto;
      // 上传限速： true为开启限速
      if (storageRangeSetting.speedLimit !== undefined) formData.speedLimit = storageRangeSetting.speedLimit;
      // 限速范围
      if (storageRangeSetting.speedLimitSize !== undefined)
        formData.speedLimitSize = storageRangeSetting.speedLimitSize;
      // 限速单位
      if (storageRangeSetting.speedLimitUnit !== undefined)
        formData.speedLimitUnit = storageRangeSetting.speedLimitUnit;
    },
  };

  // 从storage中读取数据
  storageMethods.initDataFromStorage();
  // 读取之后，才进行formData的记录
  const { isEqual, clearFormDataCache } = formEqualHandler(formData);
  return {
    isEqual,
    clearFormDataCache,
    storageMethods,
    setStorage,
  };
};
